import { types } from './actions';

const initialState = {
  isSaving: false,
};

const reducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case types.UPDATE_BUSINESS_NAME_ERROR:
      return {
        ...state,
        isSaving: false,
      };
    case types.UPDATE_BUSINESS_NAME_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case types.UPDATE_BUSINESS_NAME_SUCCESS:
      return {
        ...state,
        isSaving: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.company.companyName;

export const isSaving = (state) => getScope(state).isSaving;
